import {Component, EventEmitter, Input, Output} from '@angular/core';


@Component({
  selector: 'lcms-text-filter-table',
  templateUrl: './text-filter-table.component.html',
  styleUrls: ['./text-filter-table.component.scss'],
})
export class TextFilterTableComponent {
 @Input() Items = [];
 @Input() Multiple? = true
 @Input() Loading = false;
@Output() listFilters = new EventEmitter<any[]>();
selected : any[] = []
  getList(event: any) {
  if(this.Multiple){

  this.selected.push(event)
    this.listFilters.emit( this.selected);
  }else {
    this.listFilters.emit( [this.selected]);
  }
  }

  search(search: string) {
   this.Items.filter((item) => item===search)
  }

  removeItem(item: any) {
    this.selected  = this.selected.filter((cat :any)=>cat.id !==item.id);
    this.listFilters.emit( this.selected);
  }
}
